import type { RolePermissions } from "../components/PermissionsContext";

export type PermissionAction = { value: string; label: string };

export type PermissionResource = {
  key: keyof RolePermissions;
  label: string;
  actions: PermissionAction[];
};

export type PermissionGroup = {
  key: string;
  label: string;
  resources: PermissionResource[];
};

const crud: PermissionAction[] = [
  { value: "view", label: "Visualizar" },
  { value: "create", label: "Criar" },
  { value: "edit", label: "Editar" },
  { value: "delete", label: "Deletar" },
];

export const PERMISSION_GROUPS: PermissionGroup[] = [
  {
    key: "org",
    label: "Organização",
    resources: [
      { key: "orgInfos", label: "Informações da Organização", actions: crud },
      { key: "orgCollaborators", label: "Colaboradores", actions: crud },
      {
        key: "orgRoles",
        label: "Cargos",
        actions: [
          ...crud,
          { value: "grant", label: "Atribuir" },
          { value: "revoke", label: "Revogar" },
        ],
      },
      {
        key: "orgPayments",
        label: "Cobrança por Pix Automático",
        actions: crud,
      },
    ],
  },
  {
    key: "ads",
    label: "Anúncios",
    resources: [
      {
        key: "roomRadioAds",
        label: "Rádio",
        actions: [...crud, { value: "setBudget", label: "Definir orçamento" }],
      },
      {
        key: "roomTvAds",
        label: "TV",
        actions: [...crud, { value: "setBudget", label: "Definir orçamento" }],
      },
      // `key` is the contract (it indexes RolePermissions and is what the
      // backend stores); `label` is the only thing a user reads, and the
      // product name for that surface is Átrio — matching the ads page tab
      // (ads.tsx: Title "Átrio") and the /negociar navbar.
      { key: "hallAds", label: "Átrio", actions: crud },
    ],
  },
  {
    key: "negotiation",
    label: "Negociação",
    resources: [
      {
        key: "bid",
        label: "Lances e patrocínio",
        actions: [
          { value: "view", label: "Visualizar posts" },
          { value: "create", label: "Dar lance" },
          { value: "viewRanking", label: "Ver ranking" },
          { value: "viewHistory", label: "Ver histórico" },
        ],
      },
      {
        key: "handleNegotiateConfigs",
        label: "Configurações de negociação",
        actions: [
          { value: "view", label: "Visualizar" },
          { value: "edit", label: "Editar" },
        ],
      },
      {
        key: "report",
        label: "Denunciar posts",
        actions: [
          { value: "view", label: "Ver denúncias" },
          { value: "create", label: "Denunciar" },
        ],
      },
    ],
  },
  {
    key: "billing",
    label: "Faturas & Dashboard",
    resources: [
      {
        key: "invoices",
        label: "Faturas",
        actions: [
          { value: "view", label: "Visualizar" },
          { value: "export", label: "Baixar PDF" },
        ],
      },
      {
        key: "dashboard",
        label: "Dashboard / Métricas",
        actions: [{ value: "view", label: "Visualizar" }],
      },
    ],
  },
  {
    key: "supportAndMedia",
    label: "Suporte & Mídia",
    resources: [
      {
        key: "support",
        label: "Suporte (tickets)",
        actions: [
          { value: "view", label: "Visualizar tickets" },
          { value: "create", label: "Abrir ticket" },
        ],
      },
      {
        key: "media",
        label: "Uploads de mídia",
        actions: [
          { value: "view", label: "Visualizar biblioteca" },
          { value: "upload", label: "Fazer upload" },
        ],
      },
    ],
  },
];
